import Button from '@/components/atom/Button';
import LucideIcon from '@/components/atom/Icons/LucideIcon';
import BottomFixedContainer from '@/components/molecule/BottomFixedContainer';
import MainContentTitle from '@/components/molecule/MainContentTitle';
import SectionCard from '@/components/molecule/SectionCard';
import { BUTTON_CONST } from '@/src/constants/buttons';
import PATH from '@/src/routes/path';
import { useNavigate } from 'react-router-dom';
import SectionLabel from '@/components/molecule/SectionLabel';
import Typo from '@/components/atom/Typo';
import { useForm } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import {
  testDefaultValues,
  testFormResolver,
} from '@/src/pages/TestPage/EditTest/form';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import FormSection from '@/components/organism/FormSection';
import { FormSctionRenderer } from '@/components/organism/FormSection/renderer';

const BACK_PATH = PATH.FILTER_TEST;
const EDIT_PATH = PATH.FORM_TEST;

export default function EditTestPage() {
  // util
  const navigate = useNavigate();

  // query
  const { data, isFetched } = useQuery({
    queryKey: ['testForm'],
    queryFn: () => {
      return {
        text: 'default12312',
        radio: 'false',
        select: 'option1',
        'select&input': 'test1',
        'select&input2': 'option4',
        media: null,
        media2: [],
        date: '',
      };
    },
  });

  // form
  const form = useForm({
    resolver: testFormResolver(),
    defaultValues: testDefaultValues,
  });

  // render
  const renderBottomFixedContent = () => {
    return (
      <BottomFixedContainer>
        <div className="flex justify-between">
          <Button
            className="w-max"
            buttonSize="medium"
            buttonColor="outline"
            onClick={() => navigate(BACK_PATH)}
          >
            <div className="flex items-center gap-x-2">
              <LucideIcon name="ChevronLeft" size={16} />
              {BUTTON_CONST.backToList}
            </div>
          </Button>
          <Button
            className="w-40"
            buttonSize="medium"
            buttonColor="outline"
            onClick={() => navigate(EDIT_PATH)}
          >
            <div className="flex items-center gap-x-2">{BUTTON_CONST.edit}</div>
          </Button>
        </div>
      </BottomFixedContainer>
    );
  };

  // effect
  //
  useEffect(() => {
    if (Object.keys(form.formState.errors).length > 0) {
      form.trigger();
    }
  }, [form]);

  // form 기본값 세팅
  useEffect(() => {
    if (isFetched) {
      form.reset(data);
    }
  }, [data, form, isFetched]);

  return (
    <article className="pb-fixedFooterUsedPadding">
      <MainContentTitle
        breadcrumbList={['test1', 'test2']}
        pageTitle="testDetail"
      />
      <div className="flex flex-col gap-4">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(() => {})}>
            <button type="submit" className="hidden" />
            <FormSection
              sectionTitle="수정 테스트"
              form={form}
              contents={[
                [
                  {
                    name: 'text',
                    label: 'text',
                    isRequired: true,
                    render: FormSctionRenderer.TEXT(),
                  },
                  {
                    name: 'radio',
                    label: 'radio',
                    render: FormSctionRenderer.RADIO({
                      options: [
                        {
                          label: (
                            <div className="flex flex-col gap-1">
                              <p>Y</p>
                              <p>Test</p>
                            </div>
                          ),
                          value: 'true',
                        },
                        { label: 'N', value: 'false' },
                      ],
                    }),
                  },
                  {
                    name: ['select&input', 'select&input2'],
                    label: 'select&input',
                    render: FormSctionRenderer.SELECT_WITH_INPUT({
                      options: [
                        { label: 'test1', value: 'test1' },
                        { label: 'test2', value: 'test2' },
                        { label: 'test3', value: 'test3' },
                      ],
                    }),
                    isRequired: true,
                    placeholder: ['선택', '입력'],
                  },
                  {
                    name: 'media',
                    label: 'media',
                    isRequired: true,
                    render: FormSctionRenderer.IMAGE_UPLOAD(),
                  },
                  {
                    name: 'media2',
                    label: 'media2',
                    isRequired: true,
                    render: FormSctionRenderer.IMAGE_UPLOAD({
                      isMultiple: true,
                      maxLength: 5,
                    }),
                  },
                  {
                    name: 'date',
                    label: 'date',
                    isRequired: true,
                    render: FormSctionRenderer.DATE(),
                  },
                ],
                [
                  {
                    name: 'test1',
                    label: 'test1',
                  },
                  {
                    name: 'test1',
                    label: 'test1',
                  },
                  {
                    name: 'test1',
                    label: 'test1',
                  },
                ],
              ]}
            />
          </form>
        </Form>
        <SectionCard cardTitle="content1">
          <div className="grid grid-cols-[1fr_auto_1fr] gap-x-6 gap-y-4">
            <div className="col-span-1 flex flex-col gap-y-6">
              <SectionLabel
                label="test"
                value={
                  <Typo typoType="h20sb" typoColor="blue9">
                    HRM
                  </Typo>
                }
              />
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
            </div>

            <div className="border-r border-r-gray1" />

            <div className="col-span-1 flex flex-col gap-y-6">
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
              <SectionLabel label="test" value="test" />
            </div>
          </div>
        </SectionCard>
      </div>
      {renderBottomFixedContent()}
    </article>
  );
}
